import React from "react";

const WhoWeAre = ({ data }) => {

  console.log("Data-------->",data);
  return (
    
    <>
      <article
        style={{ backgroundImage: "url('./img/about/whoWeAre-bg.png')" }}
        className="who-we-are py-5"
      >
        <h2 className="text-black fw-bold display-3 text-center my-4">
          Training and placement{" "}
          <span style={{ color: "#FE7743" }} className="fw-semibold">
            {" "}
            of Rural BPL youth in the Various States of INDIA
          </span>{" "}
        </h2>
        <p className="container col-md-9 fs-5 text-center">
          The institution has established several ultra modern training centres
          with huge capacity and has trained and employed over 29000 people
          predominately below poverty line till now. We have also setup centres
          in Jharkhand and trained morethan8400peopletill date.{" "}
        </p>

        <div className="px-md-5 px-2 row row-cols-1 gap-3 gap-md-0  row-cols-md-2">
          <div className="text-center">
            <img
              src="/img/about/ocfit-map.png"
              alt=""
              className="w-full h-full object-contain"
            />
          </div>
          <div
            className="fs-5 text-center"
            style={{ display: "flex", justifyContent: "space-around" }}
          >
            <table
              className="w-full"
              border="1"
              cellpadding="10"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>Target States</th>
                  <th>No. of Students</th>
                </tr>
              </thead>
              <tbody>
                {data?.trainingCenters?.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item?.state}</td>
                    <td>{item?.students}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <strong>Total Students Trained</strong>
                  </td>
                  <td>
                    {/* <strong>{data.trainingCenters?.reduce((acc))}</strong> */}
                    <strong>{data?.trainingCenters?.reduce((sum, item) => sum + parseInt(item.students, 10), 0)}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </article>
    </>
  );
};

export default WhoWeAre;
